import React from 'react';

const TextView = ({ text }) => {
    return (
        <div className="text-content">
            {text}
        </div>
    )
}

export default TextView;